import React, { useLayoutEffect, useMemo, useRef } from "react";

import "./course.cmp.scss";
import CourseTreeCmp from "./course.tree/course.tree.cmp";
import CoursePlayer from "./course.player/course.player.cmp";
import CourseComander from "../../store/commanders/course.comander";
import { useMediaQuery } from "react-responsive";
import PublicityBanner from "../publicity-banner/publicity-banner.component";
import {
  DEMO_PUBLICITY_BANNER,
  getEnvPublicityBanner,
  isPublicityEnabled,
  resolvePublicityBanner,
} from "../../helpers/publicity.banner.helper";

const CourseComponent = ({
  course,
  selected,
  userName,
  state,
  isUserAdmin,
  getTranscripts,
  showFeedbackForStudent,
  showCongrats,
  submitFeedback,
  userCertificates,
}) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 992px)" });
  const selectedBanner = selected?.banner;
  const selectedPublicityBanner = selected?.publicityBanner;
  const selectedAdvertisementBanner = selected?.advertisementBanner;
  const courseBanner = course?.banner;
  const coursePublicityBanner = course?.publicityBanner;
  const courseAdvertisementBanner = course?.advertisementBanner;
  const courseBannersCourse = course?.banners?.course;
  const courseBannersDefault = course?.banners?.default;
  const courseBannerEnabled = isPublicityEnabled({
    area: "COURSE",
    kind: "BANNER",
  });
  const coursePageBanner = useMemo(
    () =>
      courseBannerEnabled
        ? resolvePublicityBanner(
            selectedBanner,
            selectedPublicityBanner,
            selectedAdvertisementBanner,
            courseBanner,
            coursePublicityBanner,
            courseAdvertisementBanner,
            courseBannersCourse,
            courseBannersDefault,
            getEnvPublicityBanner("COURSE"),
            DEMO_PUBLICITY_BANNER,
          )
        : null,
    [
      courseBannerEnabled,
      courseAdvertisementBanner,
      courseBanner,
      courseBannersCourse,
      courseBannersDefault,
      coursePublicityBanner,
      selectedAdvertisementBanner,
      selectedBanner,
      selectedPublicityBanner,
    ],
  );

  const onSelect = (item) => {
    CourseComander.cmd_select_section(item);
  };

  const treeRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    // const handleResize = () => {
    //   if (treeRef.current && contentRef.current) {
    //     const navbarHeight =
    //       document.querySelector(".navbar-container")?.clientHeight || 0;
    //     const screenHeight = window.innerHeight;
    //     const availableHeight = screenHeight - navbarHeight;
    //     const contentHeight = contentRef.current.clientHeight;
    //     treeRef.current.style.height =
    //       contentHeight > 500
    //         ? `${contentHeight + (selected?.type === "video" ? 250 : 0)}px`
    //         : `${availableHeight}px`;
    //   }
    // };
    // window.addEventListener("resize", handleResize);
    // handleResize(); // Call on mount
    // return () => {
    //   window.removeEventListener("resize", handleResize);
    // };
  }, [selected?.id]);

  return (
    <>
      <div className="course-cmp">
        <div className="course-content" ref={contentRef}>
          <PublicityBanner
            banner={coursePageBanner}
            className="course-cmp__banner"
          />
          <CoursePlayer
            selected={selected}
            course={course}
            onSelect={onSelect}
            state={state}
            userName={userName}
            isUserAdmin={isUserAdmin}
            getTranscripts={getTranscripts}
            showFeedbackForStudent={showFeedbackForStudent}
            showCongrats={showCongrats}
            submitFeedback={submitFeedback}
            userCertificates={userCertificates}
            courseTreeComponent={
              <CourseTreeCmp
                item={course}
                onSelect={onSelect}
                selected={selected}
              />
            }
          />
        </div>

        {/* Desktop Course Tree */}
        {!isTabletOrMobile && (
          <div className="course-tree" ref={treeRef}>
            <CourseTreeCmp
              item={course}
              onSelect={onSelect}
              selected={selected}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default CourseComponent;
